import React from "react";
import {
  SEO,
  PageLayout,
  ContactForm,
  createDefaultMessageFromState,
} from "@bluefin/components";
import { Grid } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getComponentFiles } from "../utils/utils";

export default class CareersPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
        />
        <PageLayout
          hero={null}
          subfooter={false}
          className={"about-page careers-page"}
        >
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            centered={true}
            textAlign={"center"}
          >
            <Grid.Column width={8} textAlign={"center"}>
              <h2>Join Our Team</h2>
              <p>
                We’re always looking for friendly, hardworking individuals to
                join our team! Apply below for positions in our convenience
                store, deli, or liquor store.
              </p>
            </Grid.Column>
          </Grid>
          <Grid
            stackable={true}
            className={"component-section-container career-form-container"}
            verticalAlign={"middle"}
            textAlign={"left"}
            centered={true}
          >
            <Grid.Column width={8}>
              <ContactForm
                constructMessage={createDefaultMessageFromState}
                fields={[
                  {
                    label: "name",
                    placeholder: "Full Name",
                    type: "input",
                    required: true,
                  },
                  {
                    label: "phone",
                    placeholder: "Phone Number",
                    type: "input",
                    required: true,
                  },
                  {
                    label: "email",
                    placeholder: "Email",
                    type: "input",
                    inputType: "email",
                    required: true,
                  },
                  {
                    label: "position",
                    displayLabel: "Position You’re Applying For?",
                    type: "select",
                    required: true,
                    options: [
                      { label: "Cashier", value: "Cashier" },
                      { label: "Cook", value: "Cook" },
                      { label: "Deli Associate", value: "Deli Associate" },
                      {
                        label: "Convenience Store Associate",
                        value: "Convenience Store Associate",
                      },
                      {
                        label: "Liquor Store Associate",
                        value: "Liquor Store Associate",
                      },
                    ],
                  },
                  {
                    label: "availability",
                    displayLabel: "Are You Available Full-Time or Part-Time?",
                    type: "select",
                    required: true,
                    options: [
                      { label: "Full-Time", value: "Full-Time" },
                      { label: "Part-Time", value: "Part-Time" },
                      { label: "Either", value: "Either" },
                    ],
                  },
                  {
                    label: "WorkExperience",
                    displayLabel: "Do You Have Relevant Work Experience?",
                    type: "select",
                    required: true,
                    options: [
                      { label: "Yes", value: "Yes" },
                      { label: "No", value: "No" },
                    ],
                  },
                ]}
                buttonText={"Send"}
                centeredHeaders={true}
                className={""}
                fluidButton={true}
                header={""}
                inline={false}
                showLabels={true}
                subheader={""}
                termsCopy={""}
                withContainer={true}
                locationId={fishermanBusiness.primaryLocation._id}
                businessId={fishermanBusiness._id}
                businessType={fishermanBusiness.type}
              />
            </Grid.Column>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      primaryLocation {
        _id
      }
      _id
      type
    }
    fishermanBusinessWebsitePage(title: { eq: "Careers" }) {
      title
      description
      components {
        fastId
        componentIdentifier
        order
        files {
          file
        }
      }
    }
  }
`;
